import type { DialogProps } from "@mui/material/Dialog";

/**
 * Wraps MUI Dialog onClose so backdrop clicks do not close the dialog.
 * Escape key and explicit controls still invoke the original handler.
 */
export function withoutBackdropClose(
  onClose: DialogProps["onClose"],
): NonNullable<DialogProps["onClose"]> {
  return (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    onClose?.(event, reason);
  };
}
